// import React, { useEffect } from "react";
// // import { WithContext as ReactTags } from "react-tag-input";
// // import { WithContext as ReactTags } from '@pathofdev/react-tag-input';

// const NodeGroupTag = ({ nodeGroup, dealTags }) => {
//   const KeyCodes = {
//     comma: 188,
//     enter: 13,
//   };
//   const delimiters = [KeyCodes.comma, KeyCodes.enter];
//   const [tags, setTags] = React.useState([]);

//   useEffect(() => {
//     let result = nodeGroup.tags.match(/(".*?"|[^",\s]+)(?=\s*,|\s*$)/g);
//     let tagsArray = [];
//     if (result !== null) {
//       for (let i = 0; i < result.length; i++) {
//         tagsArray.push({ id: result[i], text: result[i] });
//       }
//     }

//     setTags(tagsArray);
//   }, []);

//   useEffect(() => {
//     dealTags(tags);
//   }, [tags]);

//   const handleDelete = (i) => {
//     setTags(tags.filter((tag, index) => index !== i));
//   };

//   const handleAddition = (tag) => {
//     setTags([...tags, tag]);
//   };

//   const handleDrag = (tag, currPos, newPos) => {
//     const newTags = tags.slice();
//     newTags.splice(currPos, 1);
//     newTags.splice(newPos, 0, tag);
//     setTags(newTags);
//   };

//   const handleTagClick = (index) => {
//     //console.log("The tag at index " + index + " was clicked");
//   };

//   return (
//     <div className="app">
//       <div>
//         {/* <ReactTags
//           tags={tags}
//           delimiters={delimiters}
//           handleDelete={handleDelete}
//           handleAddition={handleAddition}
//           handleDrag={handleDrag}
//           handleTagClick={handleTagClick}
//           autoComplete
//           inline
//           inputFieldPosition="inline"
//         /> */}
//       </div>
//     </div>
//   );
// };

// export default NodeGroupTag;
///////////////////////////////////////////

import { useEffect, useState } from "react";
import CreatableSelect from "react-select/creatable";

const NodeGroupTag = ({ nodeGroup, dealTags }) => {
  const [tags, setTags] = useState([]);
  useEffect(() => {
    console.log(dealTags);
    const result = nodeGroup.tags.match(/(".*?"|[^",\s]+)(?=\s*,|\s*$)/g);
    if (result) {
      const formatted = result.map((tag) => ({ label: tag, value: tag }));
      setTags(formatted);
    }
  }, []);
  useEffect(() => {
    dealTags(tags);
  }, [tags]);

  return (
    <CreatableSelect
      isMulti
      value={tags}
      onChange={(newValue) => setTags(newValue || [])}
      onCreateOption={(inputValue) => {
        console.log("create:", inputValue);
        const newTag = { label: inputValue, value: inputValue };
        setTags((prev) => [...prev, newTag]);
      }}
      styles={{
        control: (base, state) => ({
          ...base,
          borderColor: state.isFocused ? "#25afa8" : base.borderColor,
          boxShadow: state.isFocused ? "0 0 0 1px #25afa8" : base.boxShadow,
          "&:hover": {
            borderColor: state.isFocused ? "#25afa8" : base.borderColor,
          },
        }),
      }}
      placeholder="Enter tag and press Enter"
    />
  );
};

export default NodeGroupTag;
